import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingBrokerConsultantBanner.css';
import { NBSP } from 'shared/constants/symbols';

interface INewbuildingBrokerConsultantBannerProps {
  buttonText?: string;
  buttonLoading: boolean;
  onClick: () => void;
}

export const NewbuildingBrokerConsultantBanner: React.FC<INewbuildingBrokerConsultantBannerProps> = ({
  buttonText = 'Давайте поподробнее',
  buttonLoading,
  onClick,
}) => {
  return (
    <section className={styles['container']} data-testid="BrokerBanner">
      <div className={styles['inner']}>
        <UIHeading1 color="text-inverted-default">
          Подберём и{NBSP}поможем купить квартиру в{NBSP}новостройке. Бесплатно!
        </UIHeading1>
        <div className={styles['description-wrapper']}>
          <UIText1 color="text-inverted-default">
            Найдём тот{NBSP}самый вариант под{NBSP}ваш{NBSP}бюджет
          </UIText1>
        </div>
        <div>
          <Button theme="fill_white_primary" loading={buttonLoading} onClick={onClick}>
            {buttonText}
          </Button>
        </div>
      </div>
    </section>
  );
};
